import Vue from 'vue'
import Main from './layouts/Main.vue'
import VModal from 'vue-js-modal'
import Snotify from 'vue-snotify/vue-snotify.min.js' /*muss für BUILD verwendet werden (Bug in library??)*/
//import Snotify from 'vue-snotify' /*kann für DEV verwendet werden*/
import _ from 'lodash'
import Vuex from 'vuex'
import axios from 'axios'
import VueRouter from 'vue-router'
import VueLocalForage from 'vue-localforage'

// localForage-startsWith lets us easily load all keys that begin with a string
// npm install localforage-startswith
// --> https://matthiashager.com/complete-vuejs-application-tutorial/localstorage-vuejs

Vue.use(Vuex)
import store from './store'

Vue.use(require('vue-moment'))

Vue.use(VueLocalForage)
/*
Vue.$storageConfig({
	name: 'erp' //TODO: Name beim Release anpassen
})
*/

/*
https://kazupon.github.io/vue-i18n/guide/lazy-loading.html
http://digital-cult.com/vue-i18n-async-loading-languages/
https://github.com/axios/axios
https://stackoverflow.com/questions/47597525/vue-router-alias-with-fixed-param
https://medium.com/front-end-weekly/webpack-and-dynamic-imports-doing-it-right-72549ff49234
https://markus.oberlehner.net/blog/setting-up-a-vue-project-with-webpack-4-and-babel-7/

*/

import router from './router'

Object.defineProperty(Vue.prototype, '$_', { value: _ })

Vue.use(VueRouter)
Vue.use(VModal)
Vue.use(Snotify)

/*
Vue.prototype.$globals = {
	API_URL: 'http://localhost/iceapi/',
	API_REL_URL: 'http://localhost/iceapi/'
}
*/
Vue.prototype.$globals = {
	API_URL: 'https://ice.igtag.ch/iceapi/',
	API_REL_URL: '/iceapi/',
}

new Vue({
  router,
  store,
  render: h => h(Main)
}).$mount('#app')
